let theme = window.theme || {};

export default function (modal) {
  const header = document.querySelector('[data-header]');
  const preHeader = document.querySelector('[data-pre-header]');
  const modalOverlay = modal.querySelector('[data-modal-overlay]');
  const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  let heightAbove;

  if (preHeader.offsetHeight > 0 && theme.breakpoints.current !== 'mobile' && theme.breakpoints.current !== 'tablet') {
    heightAbove = preHeader.offsetHeight + theme.breakpoints.gutters;
  } else {
    heightAbove = header.offsetHeight + theme.breakpoints.gutters;
  }

  modal.style.paddingTop = `${heightAbove}px`;

  if (modalOverlay) {
    modalOverlay.style.left = `${scrollbarWidth * -1}px`;
  }
  if (preHeader) {
    preHeader.style.right = `${scrollbarWidth}px`;
  }
  if (header) {
    header.style.right = `${scrollbarWidth}px`;
  }

  // The <main> element is employed in each page. However, it cannot be touched on the cart page,
  // it has a specific class in the cart page and modify the padding due to open a modal there would break the UI.
  // Therefore, it will modify the padding on pages where <main> element has no classes only.
  const mainContainer = document.querySelector('main');
  if (!mainContainer.classList.length) {
    mainContainer.style.paddingRight = `${scrollbarWidth}px`;
  }

  const dataFooter = document.querySelector('[data-footer]');

  if (dataFooter) {
    dataFooter.style.paddingRight = `${scrollbarWidth}px`;
  }
}
